"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaxAttributeChangedEventArgs = void 0;
const EventType_1 = require("../EventType");
class MaxAttributeChangedEventArgs {
    constructor(attribute, value) {
        this.attribute = attribute;
        this.value = value;
        this.__type = EventType_1.EventType.MaxAttributeChanged;
        this.__typeName = "MaxAttributeChanged";
    }
}
exports.MaxAttributeChangedEventArgs = MaxAttributeChangedEventArgs;
